import React, { useState } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  makeStyles,
} from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const useStyles = makeStyles(() => ({
  errorWrapper: {
    width: '100%',
    maxWidth: '300px',
    margin: 'auto',
    backgroundColor: '#ffb2a9',
    padding: '1rem',
    borderRadius: '5px',
  },
  icon: {
    margin: '1rem auto',
    display: 'flex',
    width: '30px',
    height: '30px',
    color: '#A80000'
  },
  errorStack: {
    minWidth: '80rem',
    maxHeight: '50vh'
  },
  errorMain: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column'
  },
  expandButton: {
    backgroundColor: 'white',
    color: 'blue',
    textDecoration: 'underline'
  },
  errorAccordion: {
    backgroundColor: 'transparent',
    marginBottom: '1rem'
  },
  errorMessage: {
    width: '100%'
  }
}))

const ErrorFallback = (props) => {
  const { error, resetErrorBoundary } = props
  const [hideStack, setHideStack] = useState(false)
  const classes = useStyles()
  return (
    <div className={classes.errorWrapper}>
      <ErrorIcon className={classes.icon} />
      <p>There was a problem with the application!</p>
      <Accordion className={classes.errorAccordion}>
        <AccordionSummary
          className={classes.expandButton}
          expandIcon={<ExpandMoreIcon />}
        >
          Show Details
        </AccordionSummary>
        <AccordionDetails className={classes.errorMain}>
          <div className={classes.errorMessage}>Error: {error.message}</div>
          {process.env.NODE_ENV === 'development' && !hideStack ? (
              <><pre className={classes.errorStack}>{error.stack}</pre><button onClick={() => setHideStack(true)}>hide</button></>
          ) : null}
        </AccordionDetails>
      </Accordion>
      <Button variant='contained' onClick={resetErrorBoundary}>
        Reset View
      </Button>
    </div>
  )
}

export default ErrorFallback
